import { Component, HostBinding, Input } from '@angular/core';
import { CarouselComponent } from './carousel.component';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from './carousel.component';

var _c0 = ["*"];
var SlideComponent = /** @class */ (function () {
    function SlideComponent(carousel) {
        /** Wraps element by appropriate CSS classes */
        this.addClass = true;
        this.carousel = carousel;
        //this.inactive = true;
    }
    /** Fires changes in container collection after adding a new slide instance */
    /** Fires changes in container collection after adding a new slide instance */
    SlideComponent.prototype.ngOnInit = /** Fires changes in container collection after adding a new slide instance */
    function () {
        this.carousel.addSlide(this);
    };
    /** Fires changes in container collection after removing of this slide instance */
    /** Fires changes in container collection after removing of this slide instance */
    SlideComponent.prototype.ngOnDestroy = /** Fires changes in container collection after removing of this slide instance */
    function () {
        this.carousel.removeSlide(this);
    };
    /** @nocollapse */
    SlideComponent.ctorParameters = function () { return [
        { type: CarouselComponent, },
    ]; };
    SlideComponent.propDecorators = {
        "active": [{ type: HostBinding, args: ['class.active',] }, { type: Input },],
        "addClass": [{ type: HostBinding, args: ['class.item',] }, { type: HostBinding, args: ['class.orbit-item',] },],
        //"inactive": [{ type: HostBinding, args: ['class.hide',] }, { type: Input },],
    };
SlideComponent.ɵfac = function SlideComponent_Factory(t) { return new (t || SlideComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CarouselComponent)); };
SlideComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SlideComponent, selectors: [["slide"]], hostVars: 9, hostBindings: function SlideComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-hidden", !ctx.active);
        ɵngcc0.ɵɵclassProp("hide", !ctx.active)("item", ctx.addClass)("orbit-item", ctx.addClass)("active", ctx.active);
    } }, inputs: { active: "active" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function SlideComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%] {\n      display: block;\n      position: relative;\n    }"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SlideComponent, [{
        type: Component,
        args: [{
                selector: 'slide',
                template: "\n  <ng-content></ng-content>\n  ",
                styles: [
                    "\n    :host {\n      display: block;\n      position: relative;\n    }\n  "
                ],
                host: {
                    '[attr.aria-hidden]': '!active', '[class.hide]': '!active'
                }
            }]
    }], function () { return [{ type: ɵngcc1.CarouselComponent }]; }, { addClass: [{
            type: HostBinding,
            args: ['class.item']
        }, {
            type: HostBinding,
            args: ['class.orbit-item']
        }], active: [{
            type: HostBinding,
            args: ['class.active']
        }, {
            type: Input
        }] }); })();
    return SlideComponent;
}());
export { SlideComponent };

